<template>
  <div>
    <div class="modal_inputs">
      <div v-for="(value, key) in notes" :key="key">
        Order #{{ key }}:
        <span v-html="value" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  notes: Object,
});
</script>
